
import React from 'react';
import { Button } from '@/components/ui/button';
import { Calendar, Settings, User } from 'lucide-react';
import { CardVariant } from './types';

interface PsychologistCardActionsProps {
  variant: CardVariant;
  showViewProfile: boolean;
  showBooking: boolean;
  showManagement: boolean;
  onViewProfile: (e: React.MouseEvent) => void;
  onViewFullProfile: (e: React.MouseEvent) => void;
  onBookClick: (e: React.MouseEvent) => void;
  onManageClick: (e: React.MouseEvent) => void;
}

const PsychologistCardActions: React.FC<PsychologistCardActionsProps> = ({
  variant,
  showViewProfile,
  showBooking,
  showManagement,
  onViewProfile,
  onViewFullProfile,
  onBookClick,
  onManageClick,
}) => {
  if (variant === 'admin') {
    return (
      <div className="space-y-2">
        <div className="flex gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={onViewProfile}
            className="flex-1"
          >
            Ver Perfil
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={onViewFullProfile}
            className="flex-1"
          >
            Perfil Completo
          </Button>
        </div>
        {showManagement && (
          <Button
            variant="default"
            size="sm"
            onClick={onManageClick}
            className="w-full"
          >
            <Settings className="h-4 w-4" />
            Gerenciar
          </Button>
        )}
      </div>
    );
  }

  if (variant === 'compact') {
    return (
      <div className="flex gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={onViewProfile}
          className="flex-1"
        >
          Ver Perfil
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={onViewFullProfile}
          className="flex-1"
        >
          <User className="h-4 w-4" />
        </Button>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <div className="flex gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={onViewProfile}
          className="flex-1"
        >
          Ver Perfil
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={onViewFullProfile}
          className="flex-1"
        >
          <User className="h-4 w-4 mr-1" />
          Perfil Completo
        </Button>
      </div>
      {showBooking && (
        <Button
          size="sm"
          onClick={onBookClick}
          className="w-full bg-green-500 hover:bg-green-600"
        >
          <Calendar className="h-4 w-4 mr-2" />
          Agendar
        </Button>
      )}
    </div>
  );
};

export default PsychologistCardActions;
